import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import CheckMarkIcon from '~/components/SVG/CheckMark.svg?react';

interface CheckMarkProps {
  stepStatus?: string;
  index?: number;
  activeStep?: number;
}

const getStrokeColor = (stepStatus?: string, index?: number, activeStep?: number) => {
  if (stepStatus === 'INVALID_SIGNATURE' || stepStatus === 'MISMATCHED_RNOKPP') {
    return 'warning.main';
  }

  if (stepStatus === 'inactive') {
    return 'grey.additionalGrey';
  }

  if (index === activeStep && index != null) {
    return 'common.white';
  }

  return 'primary.main';
};

const isHidden = (stepStatus?: string) =>
  stepStatus === 'withoutStatus' || stepStatus === 'NOT_VERIFIED';

const styles = {
  icon: (
    stepStatus: string | undefined,
    index: number | undefined,
    activeStep: number | undefined
  ): SxProps<Theme> => ({
    display: isHidden(stepStatus) ? 'none' : 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '30px',
    height: '18px',
    color: getStrokeColor(stepStatus, index, activeStep),
  }),
};

const CheckMark = ({ stepStatus, index, activeStep }: CheckMarkProps) => {
  return <Box component={CheckMarkIcon} sx={styles.icon(stepStatus, index, activeStep)} />;
};

export default CheckMark;
